import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocPortal, MapLocKeys } from '@cm/core/localization';

export type CPBenefitDetailLocs =
	| 'CPBenefitDetailOptInMessage'
	| 'CPBenefitDetailLabelInstructions'
	| 'CPBenefitDetailLabelType'
	| 'CPBenefitDetailLabelToken'
	| 'CPBenefitDetailLabelUrl'
	| 'CPBenefitDetailLabelUrlPreview'
	| 'CPBenefitDetailButtonGoBack'
	| 'CPBenefitDetailTitlePage'
	| 'CPBenefitDetailContentPageDescription';

export const cpBenefitDetailLocs: LocDefs<CPBenefitDetailLocs> = {
	CPBenefitDetailOptInMessage: {
		defaultValue: 'You have already opted in.',
		description:
			'Content shown on the benefit details page when benefit is of lineup type and candidate has already opted-in.',
		displayPath: `Benefits|Program|Already opted-in`,
		displayType: 'Content',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit.Lineup/Benefits.Program.Content.AlreadyOptIn',
		portal: 'CP' as LocPortal,
		htmlAllowed: true,
	},
	CPBenefitDetailLabelInstructions: {
		defaultValue: 'Instructions',
		description: 'Label for the instructions field on the benefit details page.',
		displayPath: `Benefits|Program|Field Label|Instructions`,
		displayType: 'Label',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Benefits.Program.FieldLabel.Instructions',
		portal: 'CP' as LocPortal,
	},
	CPBenefitDetailLabelType: {
		defaultValue: 'Type',
		description: 'Label for the type field on the benefit details page.',
		displayPath: `Benefits|Program|Field Label|Type`,
		displayType: 'Label',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Benefits.Program.FieldLabel.Type',
		portal: 'CP' as LocPortal,
	},
	CPBenefitDetailLabelToken: {
		defaultValue: 'Token',
		description: 'Label for the token field on the benefit details page.',
		displayPath: `Benefits|Program|Field Label|Token`,
		displayType: 'Label',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Benefits.Program.FieldLabel.Token',
		portal: 'CP' as LocPortal,
	},
	CPBenefitDetailLabelUrl: {
		defaultValue: 'Url',
		description: 'Label for the url field on the benefit details page.',
		displayPath: `Benefits|Program|Field Label|Url`,
		displayType: 'Label',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Benefits.Program.FieldLabel.Url',
		portal: 'CP' as LocPortal,
	},
	CPBenefitDetailLabelUrlPreview: {
		defaultValue: 'Preview',
		description: 'Content of the button to Preview the benefit Url',
		displayPath: `Benefits|Program|Content|Preview`,
		displayType: 'Content',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Benefits.Program.FieldLabel.UrlPreview',
		portal: 'CP' as LocPortal,
	},
	CPBenefitDetailButtonGoBack: {
		defaultValue: 'Go Back',
		description: 'Button to go back',
		displayPath: `Benefits|Program|Button|Go Back`,
		displayType: 'Button',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Benefits.Program.Button.GoBack',
		portal: 'CP' as LocPortal,
	},
	CPBenefitDetailTitlePage: {
		defaultValue: 'Benefit Details',
		description: 'Title for benefit details page',
		displayPath: 'Benefits|Program|Title|Benefit Details',
		displayType: 'Title',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Benefits.Program.Title.BenefitDetails',
		portal: 'CP' as LocPortal,
	},
	CPBenefitDetailContentPageDescription: {
		defaultValue: '',
		description: 'Page description for benefit details page',
		displayPath: 'Benefits|Program|Content|Page Description',
		displayType: 'Content',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Benefits.Program.Content.PageDescription',
		portal: 'CP' as LocPortal,
		htmlAllowed: true,
	},
};

export const LOC_KEYS = MapLocKeys<CPBenefitDetailLocs>(cpBenefitDetailLocs);
